<!-- 登录/注册流程 底部信息 -->
<template>
  <div>
        <div class="v-browser">
          {{$t('login2s.browser1')}}
          <span @click="goGoogle()">{{$t('login2s.browser2')}}</span>
          {{$t('login2s.browser3')}}
          <span @click="goIe()">{{$t('login2s.browser4')}}</span>
          {{$t('login2s.browser5')}}
        </div>
        <div class="v-browser-r" v-if="servicePhone">
          <div class="v-login-tel text-right font-size-12 v-login-footer">
            <span>{{ $t('serviceTel') }}</span>
            <span>{{ servicePhone }}</span>
          </div>
          <div class="v-login-tel text-right font-size-12 v-login-footer" v-if="serviceEmail">
            <span>{{ $t('Service Email') }}</span>
            <span>{{ serviceEmail }}</span>
          </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getAppVersion } from '@/api/index'
export default {
  name: 'vLoginBottom',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['servicePhone', 'serviceEmail'])
  },
  mounted() {
    this.getAppVersion()
  },

  methods: {
    // 获取客服电话手机号
    getAppVersion() {
      if(this.servicePhone) return
      getAppVersion()
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 && res.data) {
            this.$store.commit("SET_SERVICEPHONE", res.data.serviceMobile)
            this.$store.commit("SET_SERVICEEMAIL", res.data.serviceEmail)
          }
        })
    },
    goGoogle(){
      window.open('https://www.google.cn/chrome/','_blank')
    },
    goIe() {
      window.open('https://support.microsoft.com/zh-cn/help/17621/internet-explorer-downloads','_blank')
    }
  }
}
</script>
<style lang="stylus">
.v-browser{
    position absolute 
    bottom: 15px;
    line-height 18px;
    color: $color-black-35;
    font-size: 12px;

    span{
        color: $color-main
        text-decoration:underline;
        cursor:pointer
    }
}
.v-browser-r{
    color: $color-black-35;
    position: absolute;
    right: 20px;
    bottom: 15px;
    line-height 18px;
}
.v-login-tel{
    color: $color-black-35;
    span{
        margin-left 5px
    }
}
</style>
